var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('list-page',{attrs:{"columns":_vm.columns,"headers":_vm.headers,"popupComponent":_vm.popupComponent,"title":"More Special Client List","icon":"mdi-star-three-points","addButtonText":"More Special Client","stateendpoint":"fixClient.fixClients","basic-data":_vm.basicData,"actions":_vm.actions,"param1":4}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }